import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Printer, Shirt, Gift, ArrowRight, BoxIcon } from 'lucide-react';
export function ServicesPage() {
  const services = [{
    title: 'Screen Printing',
    description: 'High-quality, durable prints perfect for bulk orders, teams, and events. Vibrant colors that last wash after wash.',
    icon: Printer,
    link: '/services/screen-printing',
    color: 'bg-blue-50 text-blue-600'
  }, {
    title: 'Embroidery',
    description: 'Professional, textured stitching for hats, polos, and corporate wear. Adds a premium touch to any garment.',
    icon: BoxIcon,
    link: '/services/embroidery',
    color: 'bg-purple-50 text-purple-600'
  }, {
    title: 'Custom Apparel',
    description: 'Full-service apparel design and production. From t-shirts to hoodies, we bring your vision to life.',
    icon: Shirt,
    link: '/services/custom-apparel',
    color: 'bg-teal-50 text-teal-600'
  }, {
    title: 'Personalized Gifts',
    description: 'Unique, one-of-a-kind items for special occasions. Mugs, bags, and accessories customized just for you.',
    icon: Gift,
    link: '/services/personalized-gifts',
    color: 'bg-pink-50 text-pink-600'
  }];
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-715">
      <Header data-id="element-716" />

      <main className="flex-grow" data-id="element-717">
        {/* Hero */}
        <section className="bg-gradient-to-br from-purple-900 to-indigo-900 text-white py-20 md:py-32" data-id="element-718">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-719">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-720">
              Professional Custom Apparel Services
            </h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto mb-10" data-id="element-721">
              From screen printing to embroidery, we provide top-tier
              customization services for businesses, schools, and individuals in
              Southern Maryland and beyond.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-722">
              Get a Free Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-723" />
            </a>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 md:py-32" data-id="element-724">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-725">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-726">
              {services.map(service => <a key={service.title} href={service.link} className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all border border-gray-100 hover:border-purple-200 flex flex-col" data-id="element-727">
                  <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 ${service.color} group-hover:scale-110 transition-transform`} data-id="element-728">
                    <service.icon className="h-8 w-8" data-id="element-729" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-purple-600 transition-colors" data-id="element-730">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow" data-id="element-731">
                    {service.description}
                  </p>
                  <div className="flex items-center text-purple-600 font-medium group-hover:translate-x-2 transition-transform" data-id="element-732">
                    Learn more <ArrowRight className="ml-2 h-4 w-4" data-id="element-733" />
                  </div>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-gray-50 py-20" data-id="element-734">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-735">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-736">
              Not sure which service you need?
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-737">
              Our team of experts can help guide you to the perfect solution for
              your project, budget, and timeline. We've been helping the
              community since 2014.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-3 border-2 border-purple-600 text-purple-600 font-bold rounded-full hover:bg-purple-600 hover:text-white transition-all" data-id="element-738">
              Contact Our Team
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-739" />
    </div>;
}